###
# Трансформеры
###
App.MixedTransform = DS.Transform.extend
  deserialize: (serialized) -> serialized
  serialize: (deserialized) -> deserialized
